export default {
  setpointEnter: 'Erster wert im Band',
  durationMinusLimit: 'Minimale Dauer',
  realDuration: 'Dauer',
  durationPlusLimit: 'Maximale Dauer',
  totalTime: 'Gesamte Verweildauer im Band',
};
